import math from 'mathjs';
import MA from './MA';

/**
 * 定义计算布林线类
 */
class BOLL {
    /**
     * 计算布林线构造函数
     * @param {Array<Number>} closes 收盘价
     */
    constructor(closes = []) {
        this.closes = closes;
        this.ups = []; // 上轨
        let ma = new MA(closes);
        this.mbs = ma.calculateMA(20); // 中轨
        this.dns = []; // 下轨

        this.seriesOptions = [
            {
                name: 'BOLL',
                type: 'line',
                data: [],
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: '#2DB52D',
                    opacity: 0.5,
                    width: 1
                }
            },
            {
                name: 'UB',
                type: 'line',
                data: [],
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: '#D89640',
                    opacity: 0.5,
                    width: 1
                }
            },
            {
                name: 'LB',
                type: 'line',
                data: [],
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color: '#E08FE0',
                    opacity: 0.5,
                    width: 1
                }
            }
        ];
    }

    /**
     * 计算布林线
     * @param {Number} dayCount 要计算几天的标准差
     * @param {Number} k 系数k
     */
    calculate(dayCount = 20, k = 2) {
        this.ups = [];
        this.dns = [];
        for (let index = 0; index < this.closes.length; index++) {
            let up = NaN;
            let dn = NaN;
            if (index < dayCount - 1) {
                this.ups[index] = up;
                this.dns[index] = dn;
                continue;
            }

            let sum = 0;
            let ma = this.mbs[index];
            for (let i = index - dayCount + 1; i <= index; i++) {
                let close = this.closes[i];
                let difference = math.subtract(close, ma);
                sum = math.add(sum, math.pow(difference, 2));
            }

            let std = math.sqrt(math.divide(sum, dayCount));
            let base = math.multiply(k, std);
            up = math.add(ma, base);
            dn = math.subtract(ma, base);

            this.ups[index] = up;
            this.dns[index] = dn;
        }
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        return this.seriesOptions.map((option, index) => {
            switch (index) {
                case 0:
                    option.data = this.mbs;
                    break;
                case 1:
                    option.data = this.ups;
                    break;
                case 2:
                    option.data = this.dns;
                    break;
            }
            return option;
        });
    }
}

export default BOLL;



// WEBPACK FOOTER //
// ./src/controller/series/BOLL.js